import './scss/pages/archive-post.scss';
import { searchFilters } from './js/components/search-filters.js';

window.addEventListener( 'DOMContentLoaded', () => {

	searchFilters();

} );
